import { ConfigurationTypes } from '../const/ConfigurationTypes';
import IConfiguration from '../managers/contracts/configurations/IConfiguration';
export default abstract class AbstractGameGeneralConfig implements IConfiguration {
    type: ConfigurationTypes = ConfigurationTypes.GAME;
}
